import React from 'react';

import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Link, Tooltip } from '@mui/material';

import { useGetChatOrigin } from '~/hooks/apis/trip-planner/useGetChatOrigin';
import useCurrentTenant from '~/hooks/useCurrentTenant';

import { customerPortalHost } from '~/services/common';

import { chatSurfacePath } from './chatSurfaceLink';

export default function ChatStaffViewLink({ chatId }: { chatId: string }) {
  const { tenant } = useCurrentTenant();
  const { data: origin, isPending, isError } = useGetChatOrigin(chatId);
  const destination = new URL(`${customerPortalHost(tenant)}${chatSurfacePath(chatId, origin)}`);
  destination.searchParams.set('staffView', '1');
  const url = destination.toString();
  return (
    <Tooltip title={url}>
      <Link
        href={isPending || isError ? undefined : url}
        target="_blank"
        rel="noopener noreferrer"
        underline="hover"
        variant="body2"
        sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5, whiteSpace: 'nowrap' }}
      >
        {isPending ? 'Loading staff link…' : isError ? 'Staff link unavailable' : 'Open staff view'}{' '}
        <OpenInNewIcon fontSize="inherit" />
      </Link>
    </Tooltip>
  );
}
